import { useFetch } from '@/composables/useFetch';
import { useEnvStore } from '@/stores/envStore';
import { computed, ref } from 'vue';

export interface Country {
  name: string;
  alpha2_code: string;
  iso_code: string;
  currency_symbol: string;
  flag_emoji: string;
}

const countries = ref<Country[]>([]);
const isLoaded = ref(false);

export function useCountries() {
  const { fetchData } = useFetch();

  const loadCountries = async () => {
    if (isLoaded.value) return;

    const { data } = await fetchData(useEnvStore().apiUrl + '/countries');
    if (data) {
      countries.value = data as Country[];
      isLoaded.value = true;
    }
  };

  const getCountryByCode = (code: string | null | undefined) => {
    if (!code || !countries.value.length) return null;
    return countries.value.find((c) => c.alpha2_code === code) || null;
  };

  const formatCountryDisplay = (
    code: string | null | undefined,
    options?: {
      showFlag?: boolean;
      showCurrency?: boolean;
    },
  ) => {
    const country = getCountryByCode(code);
    if (!country) return '-';

    const parts: string[] = [];
    if (options?.showFlag !== false) parts.push(country.flag_emoji);
    parts.push(country.name);
    if (options?.showCurrency) parts.push(`(${country.currency_symbol})`);

    return parts.join(' ');
  };

  return {
    countries: computed(() => countries.value),
    isLoaded: computed(() => isLoaded.value),
    loadCountries,
    getCountryByCode,
    formatCountryDisplay,
  };
}
